import createPortal from 'helpers/createPortal';

export default createPortal('Banner') as any;
